module.exports = __webpack_public_path__ + "static/media/react-badge.02c392cd.svg";